{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Tingnan ang Lahat ng Opsyon",
  "Spoiler_Reveal_Tooltip": "I-click para ipakita",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "I-tweet ito",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Na-collapse ang item",
  "Spoiler_Reveal_Video_CTA": "Ipakita ang Video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "I-expand ang larawan",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Tingnan ang Laht ng Resulta",
  "Spoiler_Reveal_Image_Placeholder": "May spoiler ang larawang ito",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Maghanap sa slider",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Maaari kang bumot sa higit sa isang sagot.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Magpakita ng higit pang mga kontrol sa audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Isara",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Nilo-load ang {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Magbasa pa",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "May spoiler ang gallery na ito",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Mag-book Na",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "I-unmute",
  "Spoiler_Reveal_Gallery_CTA": "Ipakita ang Gallery",
  "Poll_Viewer_ShowLess_CTA": "Magpakita ng kaunti",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "I-mute",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymous",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sundan",
  "VerticalEmbed_Products_Button": "Bumili Na",
  "Poll_Viewer_Toast_Error_ServerDown": "Hindi makakonekta sa server. Subukan ulit sa ibang pagkakataon.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} tao ang bumot para sa sagot na ito",
  "Poll_Viewer_VoteCount": "{{number}} boto",
  "VerticalEmbed_Events_Button": "Magparehistro Na",
  "Spoiler_Reveal_Image_CTA": "Ipakita ang Larawan",
  "Poll_Viewer_Toast_Error_Connection": "Walang internet. Suriin ang iyong koneksyon.",
  "Poll_Viewer_Visibility_Owner_Footer": "Ikaw lang ang maaaring makakita sa mga resulta.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} (na) tao ang bumoto para sa sagot na ito",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Na-expand ang item",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "May spoiler ang video na ito",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Tingnan ang buong post",
  "UploadFile_Viewer_Download": "I-download ang {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}h",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
